module.exports = __webpack_public_path__ + "img/logo.7b8cc895.661bd65b.png";